export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const EXPIRED_TOKEN = 498;
export const PAGE_NOT_FOUND = 404;

const restCodes = { BAD_REQUEST, UNAUTHORIZED, EXPIRED_TOKEN };

export default restCodes;
